import {Injectable} from '@angular/core';
import {notificationButtonLabel, NotificationType} from '../enum/notification-type';
import {UserPerformanceTab} from '../enum/user-performance-tab';

@Injectable({
  providedIn: 'root',
})
export class RouteBuilder {

  organogram(sectorId: string, companyId: string) {
    return `/sectoren/${sectorId}/bedrijven/${companyId}/organogram`;
  }

  build(type: NotificationType, params: any) {
    const name = notificationButtonLabel[type];

    switch (type) {
      case NotificationType.ADDEMPLOYEE:
      case NotificationType.ALIVESHAREDCOACH:
      case NotificationType.ALIVESHAREDMANAGER:
        return {link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`, name};

      case NotificationType.COMPLETEDASSESSMENT:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.ASSESSMENT_OVERVIEW},
          name
        };

      case NotificationType.CREATEPMMANAGER:
      case NotificationType.PMREADYFORAPPROVAL:
      case NotificationType.PMSETTOACTIVE:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.PM},
          name
        };

      case NotificationType.CREATEPOPMANAGER:
      case NotificationType.POPREADYFORAPPROVAL:
      case NotificationType.POPSETTOACTIVE:
      case NotificationType.ONBOARDING:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.POP},
          name
        };

      case NotificationType.ALIVESHAREDNOCOACH:
      case NotificationType.ASSESSMENTAVAILABLEEMPLOYEE:
        return {link: `/sectoren/${params['sectorId']}/assessments/${params['assessmentId']}`, name};

      case NotificationType.MEETINGREADYFORAPPROVAL:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.MESSAGE_LOG},
          name
        };
      case NotificationType.POPFEEDBACKREQUEST:
        return {
          link: `/sectoren/${params['sectorId']}/feedback/pop/${params['popId']}`,
          name
        };
      case NotificationType.PMFEEDBACKREQUEST:
        return {
          link: `/sectoren/${params['sectorId']}/feedback/pm/${params['pmId']}`,
          name
        };
      case NotificationType.POPSELFREFLECTIONREQUEST:
        return {
          link: `/sectoren/${params['sectorId']}/feedback/pop/${params['popId']}`,
          name
        };
      case NotificationType.PMSELFREFLECTIONREQUEST:
        return {
          link: `/sectoren/${params['sectorId']}/feedback/pm/${params['pmId']}`,
          name
        };
      case NotificationType.POPFEEDBACKCOMPLETED:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.POP},
          name
        };
      case NotificationType.PMFEEDBACKCOMPLETED:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.PM},
          name
        };
      case NotificationType.POPSELFREFLECTIONCOMPLETED:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.POP},
          name
        };
      case NotificationType.PMSELFREFLECTIONCOMPLETED:
        return {
          link: `/sectoren/${params['sectorId']}/ontwikkeling/${params['userId']}`,
          queryParams: {tab: UserPerformanceTab.PM},
          name
        };

      default:
        return {link: '', name: 'Bekijk'};
    }
  }

}
